import { Alert, Container, Typography } from "@mui/material";
import Mode from "../components/styles/Mode";
import { useEffect, useState } from "react";
import Spacebox from "../components/Spacebox";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import '../css/form.css'
import '../css/calculator.css'
import cookies from "../utilities/Cookies";
import { useDispatch } from "react-redux";
import { updatedarkmode } from "../features/mode";
import constant from "../utilities/Constants";
import Button from "../components/Button";
import Grid from "../components/Grid";
import Flexbox from "../components/Flexbox";
import requests from "../handlers/requests";
import { Ring } from "@uiball/loaders";
import usePostHeight from "../hooks/useiFrameHeight";
import Results from "../components/Results";
import { isPlausibleHumanName, isValidEmail, isValidUSPhoneNumber } from "../utilities/utils";
import algorithms from "../utilities/Algorithms";



const Calculator = ({ title }) => {
    document.querySelector('title').innerHTML = title

    const dispatch = useDispatch()

    usePostHeight()

    const [step, setStep] = useState(1)
    const maxStep = 6

    const [loading, setLoading] = useState(false)


    const [amount, setAmount] = useState(15000)

    const debtTypes = ['Credit Cards', 'Medical Bills', 'Personal Loans', 'Collection Accounts', 'Private Student Loans']
    const incomes = ['$1,500 - $3,000', '$3,000 - $5,500', '$5,500 - $7,500', '$7,500 - $10k', '$10k+']
    const creditScores = ['500 - 550', '550 - 600', '600 - 650', '650 - 700', '700 - 750', '750+']

    const [debtType, setDebtType] = useState(debtTypes[0])
    const [state, setState] = useState(constant.states[0])
    const [income, setIncome] = useState(incomes[0])
    const [creditScore, setCreditScore] = useState(creditScores[0])

    const [result, setResult] = useState(null)

    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const [agreed, setAgreed] = useState(false)

    const [showError, setShowError] = useState(null)

    // eslint-disable-next-line
    const tiers = [
        {
            tier: 'tier 1',
            min: 5000,
            max: 10000,
            settlement: 0.40,
            fee: 0.20,
            cost: 0.60,
            saving: 0.40,
        },
        {
            tier: 'tier 2',
            min: 10001,
            max: 20000,
            settlement: 0.40,
            fee: 0.20,
            cost: 0.60,
            saving: 0.40
        },
        {
            tier: 'tier 3',
            min: 20001,
            max: 40000,
            settlement: 0.40,
            fee: 0.15,
            cost: 0.55,
            saving: 0.45
        },
        {
            tier: 'tier 4',
            min: 40001,
            max: 200000,
            settlement: 0.35,
            fee: 0.15,
            cost: 0.50,
            saving: 0.50
        },
    ]

    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })

    const errorAlert = (msg) => {
        setShowError(msg)
        setTimeout(() => {
            setShowError(null)
        }, 4000);
    }

    const computeValue = () => {
        setLoading(true)
        const res = algorithms.computeDebtPlan(amount)
        setResult(res)
        setStep(6)
        scrollToTop()
        setLoading(false)
    }

    const checkIfUserExists = () => {
        if (agreed === false) {
            errorAlert('Agree with terms to proceed!')
            return
        }

        setLoading(true)
        requests.get('/api/user/exists/' + email, () => { }, () => { }, errorAlert, setLoading,
            (res) => {
                if (res.url) {
                    setStep(7)
                    scrollToTop()
                }
                sendToGhl()
            },
            null,
            null
        )

    }

    const sendToGhl = () => {

        if (amount < 20000) {
            if (state === 'WV') {
                setStep(7)
                scrollToTop()
                return
            }
        }

        if (verifyInfomation() === true) {

            const urlParams = new URLSearchParams(window.location.search)
            const cluid = urlParams.get("cluid") ?? ''
            const params = window.location.href.split("?").length > 1 ? window.location.href.split("?")[1] : ''

            setLoading(true)
            // send details to ghl
            fetch('https://services.leadconnectorhq.com/hooks/1ujUGYClu0F6PlFv72Bf/webhook-trigger/e3a61ca5-4ff1-4ca5-a970-25cbcb3365a6', {
                method: 'POST',
                headers: { "Content-Type": "application/json", "Accept": "/application/json" },
                body: JSON.stringify({
                    firstname, lastname, email, phone, income, state,
                    debt_type: debtType,
                    amount: amount,
                    url_params: params,
                    cluid: cluid,
                    credit_score: creditScore
                })
            }).then(res => {
                if (res.ok)
                    return res.json()
                else
                    throw Error(res.statusText)
            }).then(res => {
                // get contact ID
                const contact_id = res.id

                // if debt amount over 10k send to custom form page
                if (amount >= 10000) {

                    // save contact to firebase
                    requests.post('/webhook/ghl-save-contact', {
                        first_name: firstname, last_name: lastname, email, phone, income, state,
                        debt_type: debtType,
                        debt_amount: amount,
                        credit_score: creditScore,
                        url_params: params,
                        contact_id
                    }, () => { }, () => { }, errorAlert, setLoading,
                        (_) => {
                            let url = `https://api.leadconnectorhq.com/widget/form/yIS7DO7192ikRtLoM1LJ?contact_id=${contact_id}&first_name=${firstname}&last_name=${lastname}&email=${email}&phone=${phone}&amount=${amount}`

                            let url2 = `https://api.leadconnectorhq.com/widget/form/4RS2FoMBvZwPu4WZt7nc?contact_id=${contact_id}&first_name=${firstname}&last_name=${lastname}&email=${email}&phone=${phone}&amount=${amount}`


                            if (amount > 20_000)
                                updateParent(url)
                            else
                                updateParent(url2)

                        },
                        null
                    )

                } else {
                    // show result
                    if (!result)
                        computeValue()
                    setStep(7)
                    scrollToTop()
                    setLoading(false)
                }



            }).catch(e => {
                errorAlert('An error occured, Try again')
                console.log(e)
            })

        } else {
            errorAlert(verifyInfomation())
        }


    }

    const updateParent = (url) => {
        window.parent.postMessage(
            { type: 'trigger', url: url },
            'https://www.finaldebtrelief.com'
        );
    };

    const changeStep = (direction) => {

        if (verify(direction) === true) {
            document.querySelector(".dynamic-container").classList.add('transition-hide')
            setTimeout(() => {
                if (direction === 'forward') {
                    if (step < maxStep)
                        setStep(step + 1)
                } else if (direction === 'back') {
                    if (step > 1)
                        setStep(step - 1)
                }
                document.querySelector(".dynamic-container").classList.remove('transition-hide')
            }, 1000);
        } else {
            errorAlert(verify())
        }
    }

    const verify = (direction) => {
        if (direction === 'back') {
            return true
        } else if (step < maxStep) {
            return true
        } else if (step === maxStep) {
            if (firstname !== '' && lastname !== '' && email.includes("@") && phone.length > 6)
                return true
            else
                return 'Please complete the form'
        }
    }

    const verifyInfomation = () => {
        if (isValidEmail(email)) {
            if (isPlausibleHumanName(firstname)) {
                if (isPlausibleHumanName(lastname)) {
                    if (isValidUSPhoneNumber(phone))
                        return true
                    else
                        return 'provide a valid phone number'
                } else
                    return 'Provide a valid last name'
            } else {
                return 'Provide a valid first name'
            }
        } else {
            return 'Provide a valid email address'
        }
    }


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            {/* WILL RENDER AS AN IFRAME. MAX WIDTH SHOULD BE 500PX */}
            <div className="calculator-page bg" style={{ transition: '.5s ease' }}>
                <div className="margin-auto mid bg" style={{ transition: '.5s ease' }}>
                    <Container sx={{ transition: '.5s ease' }}>
                        {step < maxStep + 1 && (<div style={{ padding: 20 }}>
                            <span className="big-text" style={{ opacity: 0 }}>
                                DEBT FREE
                            </span>
                            <span style={{ fontWeight: '700' }} className="text-primary bold heading">Your first step towards your <u>secure financial</u> future</span>
                            {/* Back Button */}
                            <div>
                                <div onClick={() => {
                                    changeStep('back')
                                }} className="pointer" style={{ opacity: step > 1 ? 1 : 0, visibility: step > 1 ? 'visible' : 'hidden' }} >
                                    <Spacebox padding="10px" />
                                    <Flexbox alignItems="center">
                                        <ChevronLeft className="primary-text" style={{ color: 'var(--primary)', fontSize: '17px' }} />
                                        <Spacebox padding="2.5px" />
                                        <small><b className="primary-text">Back</b></small>
                                    </Flexbox>
                                </div>
                                <Spacebox padding="5px" />
                            </div>
                            {showError && (
                                <div>
                                    <Spacebox padding="10px" />
                                    <Alert severity={"error"}>
                                        {showError}
                                    </Alert>
                                </div>
                            )}
                        </div>)}
                        {step === 1 && (
                            <div style={{ padding: 20 }} className="dynamic-container">
                                <Typography style={{ textAlign: 'center', fontSize: '14px' }}>
                                    <b>Select your debt amount balance</b>
                                </Typography>
                                <Spacebox padding="5px" />
                                <Typography className="bold text-primary" variant="h3" style={{ textAlign: 'center', fontSize: '60px' }}>
                                    ${(amount).toLocaleString()}
                                </Typography>
                                <Spacebox padding="10px" />
                                <div className="slidecontainer">
                                    <input
                                        type="range"
                                        min="10000"
                                        max="200000"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.valueAsNumber)}
                                        className="slider"
                                        step={1000}
                                        name="no-name"
                                    />
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div>
                                <div style={{ padding: 20 }} className="dynamic-container">
                                    <Typography style={{ fontSize: '14px' }}>
                                        <b>Debt Type</b>
                                    </Typography>
                                    <Spacebox padding="2px" />
                                    <select
                                        value={debtType}
                                        onChange={(e) => setDebtType(e.target.value)}
                                        name="no-name"
                                        style={{ marginTop: 0 }}
                                    >
                                        {debtTypes.map((dt, i) => (
                                            <option key={i} value={dt}>{dt}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        {step === 3 && (
                            <div>
                                <div style={{ padding: 20 }} className="dynamic-container">
                                    <Typography style={{ fontSize: '14px' }}>
                                        <b>State of Residence</b>
                                    </Typography>
                                    <Spacebox padding="2px" />
                                    <select
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                        name="no-name"
                                    >
                                        {(constant.states).map((st, i) => (
                                            <option key={i} value={st}>{st}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        {step === 4 && (
                            <div>
                                <div style={{ padding: 20 }} className="dynamic-container">
                                    <Typography style={{ fontSize: '14px' }}>
                                        <b>What's your monthly income?</b>
                                    </Typography>
                                    <Spacebox padding="2px" />
                                    <select
                                        value={income}
                                        onChange={(e) => setIncome(e.target.value)}
                                        name="no-name"
                                    >
                                        {incomes.map((st, i) => (
                                            <option key={i} value={st}>{st}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        {step === 5 && (
                            <div>
                                <div style={{ padding: 20 }} className="dynamic-container">
                                    <Typography style={{ fontSize: '14px' }}>
                                        <b>What's your credit score?</b>
                                    </Typography>
                                    <Spacebox padding="2px" />
                                    <select
                                        value={creditScore}
                                        onChange={(e) => setCreditScore(e.target.value)}
                                        name="no-name"
                                    >
                                        {creditScores.map((st, i) => (
                                            <option key={i} value={st}>{st}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        {step === 6 && (
                            <div style={{ padding: 20 }} className="dynamic-container">
                                <Grid grid={2} gap="10px">
                                    <div>
                                        <Typography style={{ fontSize: '14px' }}>
                                            <b>First Name</b>
                                        </Typography>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            name="firstname"
                                            id="firstname"
                                            value={firstname}
                                            onChange={(e) => setFirstname(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <Typography style={{ fontSize: '14px' }}>
                                            <b>Last Name</b>
                                        </Typography>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            name="lastname"
                                            id="lastname"
                                            value={lastname}
                                            onChange={(e) => setLastname(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Spacebox padding="10px" />
                                <Typography style={{ fontSize: '14px' }}>
                                    <b>Email Address</b>
                                </Typography>
                                <Spacebox padding="2px" />
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <Spacebox padding="10px" />
                                <Typography style={{ fontSize: '14px' }}>
                                    <b>Phone</b>
                                </Typography>
                                <Spacebox padding="2px" />
                                <input
                                    type="tel"
                                    name="phone"
                                    id="phone"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                                <Spacebox padding="10px" />
                                <Flexbox alignItems="flex-start">
                                    <input
                                        type="checkbox"
                                        name="agree"
                                        id="agree"
                                        value={agreed}
                                        onChange={(e) => setAgreed(e.target.checked)}
                                        style={{ width: 'fit-content' }}
                                        className="fit-content"
                                    />
                                    <Spacebox padding="2px" />
                                    <small className="terms" style={{ opacity: .5 }}>
                                        <b>We value your privacy.</b>  By clicking the button above you consent to having your credit report accessed as explained underneath. This will not impact your credit. You understand that by clicking on the button above, you are providing written instructions to our <u>partner/ affiliates <span>TurboDebt, Beyond Finance LLC dba Accredited Debt Relief, First Choice Debt Relief, National Debt Relief and Cura Debt</span> </u> under the Fair Credit Reporting Act (and all relevant State Laws) authorizing them to obtain information from your personal credit report or other information from a credit bureau for debt settlement purposes only.
                                    </small>
                                </Flexbox>
                            </div>
                        )}
                        {step < maxStep + 1 && (
                            <div className="dynamic-container">
                                <Spacebox padding="20px" />
                                <Flexbox justifyContent="space-between" alignItems="center">
                                    <div>
                                        <small style={{ opacity: .5 }}><b>{step} of {maxStep}</b></small>
                                        <Spacebox padding="2.5px" />
                                        <div style={{ width: '100px', height: '7px', borderRadius: '1000px', background: '#4A3FFF20', overflow: 'hidden' }}>
                                            <div style={{ width: `${((step) / (maxStep)) * 100}%`, height: '100%', background: 'var(--primary)', borderRadius: '1000px' }}></div>
                                        </div>
                                    </div>

                                    <div>
                                        <Button handleClick={() => {
                                            if (step === maxStep)
                                                checkIfUserExists()
                                            else if (step === maxStep - 1)
                                                computeValue()
                                            else
                                                changeStep('forward')
                                        }} style={{ background: 'var(--primary)', color: 'white', borderRadius: '5px', padding: '7px 15px' }}>
                                            {!loading && <Flexbox alignItems="center" className="white-text">
                                                <small className="white-text" style={{ fontSize: '15px', color: 'white' }}>
                                                    {step === maxStep ? 'Submit' : 'Next'}
                                                </small>
                                                <Spacebox padding="5px" />
                                                <ChevronRight className="white-text" style={{ color: 'white', fontSize: '15px' }} />
                                            </Flexbox>}
                                            {loading && (
                                                <Ring size={15} speed={0.9} color={"white"} />
                                            )}
                                        </Button>
                                    </div>
                                </Flexbox>
                            </div>
                        )}
                        {(step === maxStep + 1 && result) && (
                            <div style={{ padding: 20 }}>
                                <span className="big-text">
                                    RESULT
                                </span>
                                <span style={{ fontWeight: '700' }} className="text-primary bold heading">See results below</span>
                                <Spacebox padding="20px" />
                                <Results result={result} />
                            </div>
                        )}
                    </Container>
                </div>
                <Spacebox padding="20px" />
            </div>
        </Mode>
    );
}

export default Calculator;